module.exports = __webpack_public_path__ + "img/zg_px.61419393.jpg";